import { z } from "zod";
import { locales } from "../models.js";

export default {
  params: z.object({
    accountId: z.string(),
    email: z.email(),
    lang: z.enum(locales).default("en"),
  }),
  response: z.object({
    uid: z.string(),
  }),
};
